import { useTranslation } from 'react-i18next';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyMuiButton } from '~/legacy-components/LegacyForms';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { WorkContactEditMode } from './components/WorkContactEditMode';
import { WorkContactReadMode } from './components/WorkContactReadMode';
import { useWorkContact } from './useWorkContact';

export const WorkContact = () => {
  const { t } = useTranslation();

  const {
    empData,
    register,
    errors,
    onSubmit,
    readMode,
    setReadMode,
    companyOffice,
    control,
    handleFormReset,
    isLoading,
    canEdit,
  } = useWorkContact();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <LegacyHeadingWithActions heading={t('laWorkContact')}>
        {!readMode ? (
          <>
            <LegacyMuiButton
              onClick={onSubmit}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Save} />}
            >
              {t('laSave')}
            </LegacyMuiButton>
            <LegacyMuiButton
              onClick={handleFormReset}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Close} />}
            >
              {t('laCancel')}
            </LegacyMuiButton>
          </>
        ) : (
          <>
            {canEdit && (
              <LegacyMuiButton
                onClick={() => setReadMode(false)}
                startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Edit} />}
              >
                {t('laEdit')}
              </LegacyMuiButton>
            )}
          </>
        )}
      </LegacyHeadingWithActions>
      {readMode ? (
        <WorkContactReadMode data={empData} companyOffice={companyOffice} />
      ) : (
        <WorkContactEditMode
          data={empData}
          register={register}
          errors={errors}
          companyOffice={companyOffice}
          control={control}
        />
      )}
    </>
  );
};
